import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fa75af4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root common_layout" }
const _hoisted_2 = {
  class: "contents",
  style: {"padding-bottom":"50px"}
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "selectGoods" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-right":"11px"} }
const _hoisted_7 = { class: "goods" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  class: "right",
  style: {"height":"85px"}
}
const _hoisted_11 = {
  class: "rightTop goods_name_hidden",
  style: {"margin-top":"0"}
}
const _hoisted_12 = { class: "price" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "CNY", -1))
const _hoisted_14 = { class: "detail" }
const _hoisted_15 = { class: "detailHeader" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#303133","font-weight":"700","font-size":"18px"} }, "選擇商品詳情", -1))
const _hoisted_17 = {
  class: "box",
  style: {"margin-top":"21px"}
}
const _hoisted_18 = { class: "goods" }
const _hoisted_19 = { class: "common_font goods_name_hidden" }
const _hoisted_20 = {
  class: "left",
  style: {"margin-right":"28px"}
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "selectColor" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "規格", -1))
const _hoisted_24 = {
  class: "colors center_flex_layout",
  style: {"flex-flow":"row wrap","justify-content":"flex-start"}
}
const _hoisted_25 = {
  class: "selsevNumber",
  style: {"margin-top":"25px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "數量", -1))
const _hoisted_27 = { class: "addNumber" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"16px","height":"2px","background-color":"#a8abb2"} }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  class: "num",
  style: {"width":"84px"}
}
const _hoisted_31 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"37px"} }
const _hoisted_32 = { class: "pay" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "請輸入對應信息", -1))
const _hoisted_34 = { style: {"display":"flex","align-items":"center","margin-top":"25px"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "CNY", -1))
const _hoisted_36 = { style: {"margin-left":"35px"} }
const _hoisted_37 = { style: {"display":"flex","align-items":"center","margin-top":"20px"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "支付方式", -1))
const _hoisted_39 = { style: {"flex":"1","margin-left":"15px"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"18px","font-weight":"500","color":"#303133","margin-top":"-5px"} }, "提示", -1))
const _hoisted_41 = {
  class: "center_flex_layout",
  style: {"margin-top":"30px"}
}
const _hoisted_42 = {
  id: "qrcode",
  ref: "qrcode"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"268px","margin-top":"17px"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"#303133","font-weight":"400"} }, "請向用戶出示二維碼收款"),
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"#f56c6c"} }, "注意在用戶支付後才可關閉彈窗，否則會影響支付結果")
], -1))
const _hoisted_44 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"37px"} }

import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { get, post } from "../../utils/request";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import QRCode from "qrcodejs2";
import { Encrypt } from "../../utils/secret";

export default /*#__PURE__*/_defineComponent({
  __name: 'addGoods',
  setup(__props) {

const { proxy }: any = getCurrentInstance();

let checkPayTime;
const showMa = ref(false);
const showModal = ref(false);
const input = ref("");
const channeType = ref("");
const tradeType = ref("");
const router = useRouter();
const radio = ref("");
const radio1 = ref("");
const dialogVisible = ref(false);
// 商品详情
const goodsdetail = ref({});
// 商品规格
const skuList = ref({});
const getshow = () => {
	radio1.value = "";
	showModal.value = true;
	input.value = "";
	channeType.value = "";
};

onBeforeUnmount(() => {
	checkPayTime && clearInterval(checkPayTime);
});

const onClickCloseIcon = () => {
	const quires = document.getElementById("qrcode");
	checkPayTime && clearInterval(checkPayTime);
	channeType.value = "";
	setTimeout(() => {
		quires.innerHTML = "";
	}, 200);
};
const getType = (e: any) => {
	tradeType.value = "MWEB";
	channeType.value = e;
};
const open1 = () => {
	ElMessage({
		message: "請選擇商品規格",
		type: "warning",
		duration: 2000,
	});
};
const quxiao = () => {
	const quire = document.getElementById("qrcode");
	showMa.value = false;
	checkPayTime && clearInterval(checkPayTime);
	channeType.value = "";
	setTimeout(() => {
		quire.innerHTML = "";
	}, 200);
};
// 生成二维码
const buildCode = () => {
	if (!input.value) {
		proxy.$toast("請輸入金額");
		return;
	}

	if (!channeType.value) {
		proxy.$toast("請選擇支付方式");
		return;
	}

	showModal.value = false;
	const price = ref({
		price: input.value,
	});

	if (channeType.value === "ALIPAY") {
		tradeType.value = "FACE";
	} else {
		tradeType.value = "NATIVE";
	}

	post(`/manager/order/create`, price.value, null)
		.then((res) => {
			if (res.code == 1) {
				// console.log(res);
				const params = ref({
					id: res.result.id,
					channelType: channeType.value,
					tradeType: tradeType.value,
				});
				post("/manager/pay/init", params.value, false).then((res) => {
					if (res.code == 1) {
						showMa.value = true;
						console.log(res.result);

						setTimeout(() => {
							new QRCode("qrcode", {
								width: 200,
								height: 200,
								text: res.result,
							});
						}, 50);
					}
				});

				checkPayTime = setInterval(() => {
					checkPayState(res.result.id);
				}, 2000);
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
const goodsDetail = (id) => {
	// console.log(id);
	goodsdetail.value = "";
	skuList.value = "";
	cartdata.value.skuId = "";
	cartdata.value.id = "";
	radio.value = "";
	get(`/manager/goods/detail?goodsId=${id}`, false)
		.then((res) => {
			goodsdetail.value = res.result;
			skuList.value = res.result.skuList;
			cartdata.value.id = res.result.id;
			// console.log(cartdata.value);
			dialogVisible.value = true;
		})
		.catch((error) => {
			console.log(error);
		});
};
const changeNum = (e: any) => {
	const type = e.target.dataset.type;
	if (type === "down" && cartdata.value.num > 0) {
		cartdata.value.num -= 1;
	} else if (type === "up") {
		cartdata.value.num += 1;
	}
};
// 商品数据
const goodsList = ref({});
const getlist = () => {
	get("/manager/goods/list?page=1&size=999", null)
		.then((res) => {
			goodsList.value = res.result.list;
			console.log(goodsList.value);
		})
		.catch((error) => {
			console.log(error);
		});
};
// 获取商品列表
onMounted(() => {
	getlist();
});
// 加入购物车
const cartdata = ref({
	id: "",
	skuId: "",
	num: 1,
});
// const open = () => {
//   ElMessage({
//     message: "加入购物车成功",
//     type: "success",
//   });
// };
const limitAddCart = () => {
	proxy.$limit(addCart, 2000);
};
const addCart = () => {
	if (cartdata.value.skuId == "") {
		open1();
		return;
	} else {
		post("/manager/shopping/cart/add", cartdata.value, null)
			.then((res) => {
				if (res.code == 1) {
					dialogVisible.value = false;
					cartdata.value.num = 1;
					cartdata.value.skuId = "";
					cartdata.value.id = "";
					router.go(-1);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
};
// 选择sku
const addsku = (skuId: any) => {
	cartdata.value.skuId = skuId;
};

// 支付查询
const checkPayState = (orderId) => {
	get("/manager/pay/query/" + orderId, {}, false, false)
		.then((res) => {
			if (res.code == 1) {
				// console.log(JSON.stringify(res))
				if (res.result.payState === 2) {
					checkPayTime && clearInterval(checkPayTime);
					let passOrderId = encodeURIComponent(Encrypt(JSON.stringify(orderId)));
					router.replace("/orderDetail?orderNum=" + passOrderId);
				}
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_TopHeader, { title: "選擇商品" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodsList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (goodsDetail(item.id)),
              class: "box",
              key: item.id,
              style: {"border":"1px solid #e4e7ed","border-radius":"4px","padding":"12px 12px 8px"}
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_van_radio_group, {
                  modelValue: radio1.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radio1).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_radio, {
                      name: index + 1
                    }, null, 8, ["name"])
                  ]),
                  _: 2
                }, 1032, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: item.imgUrl,
                    alt: ""
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.goodsTitle), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(_toDisplayString(item.goodsPrice), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: dialogVisible.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      round: "",
      style: {"border-radius":"4px","width":"90%","padding":"16px"},
      closeable: "",
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(goodsdetail.value.goodsTitle), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("img", {
                    src: goodsdetail.value.imgUrl,
                    alt: ""
                  }, null, 8, _hoisted_21)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skuList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "sort",
                  key: item.id,
                  style: _normalizeStyle({ borderColor: cartdata.value.skuId === item.id ? '#409eff' : '#e4e9ee' })
                }, [
                  _createVNode(_component_van_radio, {
                    name: index + 1,
                    "icon-size": "16",
                    class: "vant",
                    modelValue: radio.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((radio).value = $event)),
                    shape: "square",
                    size: "small",
                    "checked-color": "#409eff",
                    onClick: ($event: any) => (addsku(item.id))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", {
                        class: "common_font",
                        style: _normalizeStyle({ color: cartdata.value.skuId === item.id ? '#409eff' : '#606266' })
                      }, _toDisplayString(item.specialName), 5)
                    ]),
                    _: 2
                  }, 1032, ["name", "modelValue", "onClick"])
                ], 4))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", {
                class: "anniu",
                style: {"border-right":"none"},
                "data-type": "down",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changeNum($event)))
              }, _hoisted_29),
              _createElementVNode("div", _hoisted_30, _toDisplayString(cartdata.value.num), 1),
              _createElementVNode("div", {
                class: "anniu",
                style: {"border-left":"none","font-size":"30px"},
                "data-type": "up",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changeNum($event)))
              }, " + ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogVisible.value = false)),
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (limitAddCart())),
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 確定 ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      style: {"border-radius":"4px","width":"90%","padding":"20px"},
      closeable: "",
      round: "",
      show: showModal.value,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showModal).value = $event)),
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: input.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((input).value = $event)),
                placeholder: "请输入支付金额"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_el_radio_group, {
                modelValue: radio1.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((radio1).value = $event)),
                class: "ml-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "6",
                    size: "large",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (getType('ALIPAY')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("支付宝")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "7",
                    size: "large",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (getType('WEIXIN')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("微信支付")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", {
            class: "addcode",
            onClick: buildCode,
            style: {"background-color":"#169bd5"}
          }, "生成二维码")
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: showMa.value,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((showMa).value = $event)),
      closeable: "",
      round: "",
      style: {"border-radius":"4px","width":"80%","padding":"20px"},
      "close-on-click-overlay": false,
      onClickCloseIcon: _cache[13] || (_cache[13] = ($event: any) => (onClickCloseIcon()))
    }, {
      default: _withCtx(() => [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, null, 512)
        ]),
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_el_button, { onClick: quxiao }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: quxiao
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 確定 ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})